import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductBundleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ProductBundle",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.62 26.93h-8.17c-.63 0-1.14-.51-1.14-1.14V15.57c0-.63.51-1.14 1.14-1.14h8.17c1.76 0 3.19 1.43 3.19 3.19v6.13c0 1.76-1.43 3.19-3.19 3.19Zm-7.03-2.29h7.03c.5 0 .9-.4.9-.9v-6.13c0-.5-.4-.9-.9-.9h-7.03z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.44 26.93H8.27c-1.76 0-3.19-1.43-3.19-3.19v-8.17c0-.63.51-1.14 1.14-1.14h10.22c.63 0 1.14.51 1.14 1.14v10.22c0 .63-.51 1.14-1.14 1.14M7.37 16.71v7.03c0 .5.4.9.9.9h7.03v-7.93z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.44 16.71H6.23c-.63 0-1.14-.51-1.14-1.14V7.39c0-1.76 1.43-3.19 3.19-3.19h6.13c1.76 0 3.19 1.43 3.19 3.19v8.17c0 .63-.51 1.14-1.14 1.14Zm-9.07-2.28h7.93V7.4c0-.5-.4-.9-.9-.9H8.27c-.5 0-.9.4-.9.9zM27.44 12.62h-4.62c-1.89 0-3.43-1.54-3.43-3.43V4.57c0-1.89 1.54-3.43 3.43-3.43h4.62c1.89 0 3.43 1.54 3.43 3.43v4.62c0 1.89-1.54 3.43-3.43 3.43m-4.62-9.19c-.63 0-1.14.51-1.14 1.14v4.62c0 .63.51 1.14 1.14 1.14h4.62c.63 0 1.14-.51 1.14-1.14V4.57c0-.63-.51-1.14-1.14-1.14z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.82 30.93H4.49c-1.89 0-3.43-1.54-3.43-3.43V9.17a1.14 1.14 0 1 1 2.28 0V27.5c0 .63.52 1.15 1.15 1.15h18.33a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
ProductBundleIcon.displayName = 'ProductBundleIcon';